import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * clockService is a service that provides ticking functionality at different time intervals
 * (1 second, 10 seconds, 1 minute), allowing components to subscribe to these events for
 * periodic actions. It also provides the ability to enable or disable the clock ticks temporarily.
 */
@Injectable({
    providedIn: 'root'
  })
  export class clockService implements OnDestroy {
    private _tickms = 250;
    
    private _refreshTick = new Subject<null>();
    private _onesecondTick = new Subject<null>();
    private _tensecondTick = new Subject<null>();
    private _oneminuteTick = new Subject<null>();

    /** Public observable for refresh tick events. */
    public OnRefreshTick = this._refreshTick.asObservable();

    /** Public observable for 1-second tick events. */
    public OnOneSecondTick = this._onesecondTick.asObservable();

    /** Public observable for 10-second tick events. */
    public OnTenSecondTick = this._tensecondTick.asObservable();

    /** Public observable for 1-minute tick events. */
    public OnOneMinuteTick = this._oneminuteTick.asObservable();

    private _clock_interval: any = null;

    /**
     * Initializes the clock service and starts the ticking process using setInterval.
     */
    constructor() {
        this._clock_interval = setInterval(() => {
            this._tick();
        }, this._tickms);
    }

    ngOnDestroy() {
        if (this._clock_interval) {
            clearInterval(this._clock_interval);
        }
        this._clock_interval = null;
    }

    private _enabled = new Set<string>();

    /** Returns true if no sources are disabling the clock. */
    get Enable() {
        return this._enabled.size === 0;
    }

    /**
     * Method to enable or disable the clock from a specific source.
     * If `value` is `false`, the source disables the clock.
     * If `value` is `true`, the source enables the clock, and if no sources are disabling it, the tick is triggered.
     * 
     * @param source The name of the source requesting the clock to be enabled or disabled.
     * @param value A boolean indicating whether to enable (`true`) or disable (`false`) the clock.
     */
    ClockEnable(source: string, value: boolean) {
        if (!value) {
            this._enabled.add(source); // Add source for clock disable
        } else {
            this._enabled.delete(source); // Remove source for clock enable
            if (this._enabled.size === 0) {
                this._tick();
            }
        }
    }

    private _second_count = 0;
    private _tensec_count = 0;
    private _minute_count = 0;

    private _tick() {
        this._second_count++;
        if (this._second_count >= 1000 / this._tickms) {
            this._second_count = 0;
            this._onesecondTick.next(null);
            this._tensec_count++;
            this._minute_count++;
        }

        if (this._tensec_count >= 10) {
            this._tensec_count = 0;
            this._tensecondTick.next(null);
        }

        if (this._minute_count >= 60) {
            this._minute_count = 0;
            this._oneminuteTick.next(null);
        }

        let _skip = false;
        if (this.Enable) {
            if (!_skip) {
                _skip = true;
                this._refreshTick.next(null);
                _skip = false;
            }
        }
    }
}
